import React, { useContext, useState } from 'react';
import { IconButton, MenuItem, MenuList, Paper, Popover, useTheme } from '@material-ui/core';
import AppContext from '../../../contextProvider/AppContextProvider/AppContext';
import LanguageItem from './LanguageItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CmtCard from '../../../../../@coremat/CmtCard';
import CmtCardHeader from '../../../../../@coremat/CmtCard/CmtCardHeader';
import CmtList from '../../../../../@coremat/CmtList';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CmtImage from '../../../../../@coremat/CmtImage';
import { flags, languageData } from './data';
import axios from 'axios';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { AuhMethods } from '../../../../../services/auth';
import { CurrentAuthMethod } from '../../../../constants/AppConstants';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
//import SettingsIcon from '@material-ui/icons/Settings';
import IntlMessages from '../../../../utils/IntlMessages';
import { Payment } from '@material-ui/icons';
import { THEME_TYPES } from '../../../../constants/ThemeOptions';
import { ReactComponent as SettingsIcon } from '../../../../../icons/settings.svg';
import { ReactComponent as ProfileIcon } from '../../../../../icons/profile.svg';
import { ReactComponent as LogoutIcon } from '../../../../../icons/logout.svg';
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles(() => ({
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 14,
      paddingBottom: 14,
    },
  },
  perfectScrollbarLanguage: {
    height: 324,
  },
  menuItemRoot: {
    paddingTop: 0,
    paddingBottom: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  popoverRoot: {
    '& .MuiPopover-paper': {
      width: 205,
    },
  },
}));

const LanguageSwitcher = () => {
  const classes = useStyles();
  const { locale, setLocale } = useContext(AppContext);
  const [anchorEl, setAnchorEl] = useState(null);
  var x = false,
    y = false;

  //const [darkTheme, setDarkTheme] = useState(x);
  const { authUser } = useSelector(({ auth }) => auth);
  if (authUser.darkTheme == 1) x = true;
  if (authUser.stickyMenu == 1) y = true;
  const [darkTheme, setDarkTheme] = useState(x);
  const [stickyMenu, setStickyMenu] = useState(y);

  const theme = useTheme();
  const dispatch = useDispatch();
  let history = useHistory();
  const { themeType, setThemeType } = useContext(AppContext);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'language' : undefined;

  const handlePopoverClose = () => {
    handleClose();

    history.push('/pages/profile');
  };

  const handlePopoverClose2 = () => {
    handleClose();

    history.push('/pages/upgrade');
    return;
    const token = localStorage.getItem('token');

    const senddata = {
      Action: 'get_stripe_url',
      token: token,
    };

    axios.post('https://secure.webbookingpro.com/api/pms.php', senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      window.location = res.data.Data.url;
      handleClose();
    });
  };

  const onLogoutClick = () => {
    // handlePopoverClose();
    dispatch(AuhMethods[CurrentAuthMethod].onLogout());
  };

  const handleChangeTheme = value => {
    if (value == true) setThemeType(THEME_TYPES.DARK);
    else setThemeType(THEME_TYPES.LIGHT);

    const token = localStorage.getItem('token');
    var action = 'changeUserSetting';
    if (authUser.clouduser == 1) action = 'changeCloudUserSetting';

    const senddata = {
      Action: action,
      token: token,
      Data: {
        darkTheme: value,
      },
    };
    var pmsUrl = authUser.pmsUrl;
    pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
    if (pmsUrl == '') return;

    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      setDarkTheme(value);
    });
  };

  const handleChangeTheme2 = value => {
    const token = localStorage.getItem('token');
    var action = 'changeUserSetting';
    if (authUser.clouduser == 1) action = 'changeCloudUserSetting';

    const senddata = {
      Action: action,
      token: token,
      Data: {
        stickyMenu: value,
      },
    };
    var pmsUrl = authUser.pmsUrl;
    pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
    if (pmsUrl == '') return;

    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      //   this.setState({ [name]: value });
      /* if (value == false)*/ window.location.reload();
    });
  };

  const switchLanguage = item => {
    console.log(item);
    console.log(item.locale);
    const token = localStorage.getItem('token');
    var action = 'changeUserSetting';
    if (authUser != null && authUser.clouduser == 1) action = 'changeCloudUserSetting';

    const senddata = {
      Action: action,
      token: token,
      Data: {
        language: item.locale,
      },
    };

    axios.post('https://secure.webbookingpro.com/api/pms.php', senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      setLocale(item);
      handleClose();
    });
  };

  return (
    <React.Fragment>
      <IconButton size="small" onClick={handleClick} data-tut="reactour__localization">
        <SettingsIcon className={classes.menuIcon} />
      </IconButton>

      <Popover
        className={classes.popoverRoot}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <CmtCard className={classes.cardRoot}>
          <CmtCardHeader
            title=<IntlMessages id="settings" />
            separator={{
              color: theme.palette.borderColor.dark,
              borderWidth: 1,
              borderStyle: 'solid',
            }}
          />

          <MenuList>
            <MenuItem onClick={handlePopoverClose}>
              <SvgIcon viewBox="0 0 8 11">
                <ProfileIcon className={classes.menuIcon} />
              </SvgIcon>

              <div className="ml-2">
                <IntlMessages id="profile" />
              </div>
            </MenuItem>

            {authUser != null && authUser.subscribed == 1 && (
              <MenuItem onClick={handlePopoverClose2}>
                <Payment />
                <div className="ml-2">Manage Subscription</div>
              </MenuItem>
            )}
            {authUser != null && authUser.clouduser == 0 && (
              <MenuItem onClick={onLogoutClick}>
                <LogoutIcon className={classes.menuIcon} />

                <div className="ml-2">Logout</div>
              </MenuItem>
            )}
          </MenuList>
          <FormControlLabel
            style={{ paddingLeft: '24px' }}
            control={
              <Switch
                checked={darkTheme}
                onChange={event => {
                  handleChangeTheme(event.target.checked);
                }}
                size="small"
                name="checkedA"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
            }
            label=<IntlMessages id="profile.darkTheme" />
          />

          <FormControlLabel
            style={{ paddingLeft: '24px' }}
            control={
              <Switch
                checked={stickyMenu}
                onChange={event => {
                  handleChangeTheme2(event.target.checked);
                }}
                size="small"
                name="checkedA"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
            }
            label=<IntlMessages id="profile.stickyMenu" />
          />
          <CmtCardHeader
            title=<IntlMessages id="language" />
            separator={{
              color: theme.palette.borderColor.dark,
              borderWidth: 1,
              borderStyle: 'solid',
            }}
          />
          <PerfectScrollbar className={classes.perfectScrollbarLanguage}>
            <CmtList
              data={languageData}
              renderRow={(item, index) => <LanguageItem key={index} language={item} onClick={switchLanguage} />}
            />
          </PerfectScrollbar>
        </CmtCard>
      </Popover>
    </React.Fragment>
  );
};

export default LanguageSwitcher;
